const FILTER_QUERY_PARAM_NAMES = {
  GENERIC_FILTERS: 'filtreler',
  QUERY: 'q',
  IGNORE_TOLKIEN: 'i',
  IGNORE_TYPO: 'it',
  IGNORE_CATEGORY: 'ic',
  IGNORE_BANNERS: 'ib',
  IGNORE_GENDER: 'ig',
  IGNORE_COLOR: 'ico',
  RECEIVER_TOWN_CODE: 'receiverTownCode',
}

const FILTER_QUERY_TITLES = {
  ALL_CATEGORIES: 'Tüm Kategoriler',
}

const FACET_IDS = {
  COLOR: 'renk',
  PRICE: 'fiyat',
  CATEGORY: 'category',
  RATING: 'CustomerReviewRating',
  BRAND: 'Brand',
  GENDER: 'VariantList.VariantClassification.Cinsiyet',
  AUTHOR: 'yazar',
  WORD: 'q',
  PHONE_MODEL: 'VariantList.VariantClassification.Telefon€20Modeli'
};

const FACET_TITLES = {
  RATING : 'Değerlendirme Puanı',
};

const SINGLE_SELECTION_FACET_ID_ARRAY = [
  FACET_IDS.PRICE,
];

const CUSTOM_FACET_ID_ARRAY = [
  FACET_IDS.BRAND,
  FACET_IDS.CATEGORY,
  FACET_IDS.RATING,
  FACET_IDS.WORD,
];

const FACET_FILTER_BOOST_TYPE = {
  TOP_POPULAR: 'TopPopularFilterValue',
};

const FACET_QUERY_PARAM_NAMES = {
  ...FILTER_QUERY_PARAM_NAMES,
  BRAND: 'markalar',
  RATING: 'puan',
  CATEGORY: 'kategori',
  TAG_ID: 'tagId',
  PAGE_TYPE: 'page_type',
  CITIES: 'cities',
  CITY_CODE: 'cityCode',
  BRAND_PAGE: 'brand',
  BRAND_NAME: 'brandName',
  BRAND_KEY: 'brandKey',
  RECEIVER_CITY: 'receiverCity',
  RECEIVER_TOWN: 'receiverTown',
  RECEIVER_DISTRICT: 'receiverDistrict',
  WORD: 'q',
  SORT: 'siralama',
  MAX_SIMILAR_BRANDS: 'maxResults',
};

const FACET_QUERY_PARAM_NAMES_BY_FACET_IDS = {
  [FACET_IDS.BRAND]: 'markalar',
  [FACET_IDS.RATING]: 'puan',
  [FACET_IDS.CATEGORY]: 'kategori',
  [FACET_IDS.GENERIC_FILTERS]: 'filtreler',
  [FACET_IDS.WORD]: 'q',
};

const FACET_QUERY_PARAM_NAMES_FOR_WEBTREKK = {
  [FACET_TITLES.RATING]: 'Puan',
};

export {
  FILTER_QUERY_PARAM_NAMES,
  FACET_IDS,
  SINGLE_SELECTION_FACET_ID_ARRAY,
  CUSTOM_FACET_ID_ARRAY,
  FACET_QUERY_PARAM_NAMES,
  FACET_QUERY_PARAM_NAMES_BY_FACET_IDS,
  FACET_QUERY_PARAM_NAMES_FOR_WEBTREKK,
  FILTER_QUERY_TITLES,
  FACET_FILTER_BOOST_TYPE
};
